module.exports = __webpack_public_path__ + "static/img/no4.d67fd3a6.png";